import { FC } from "react";
import { SystemEvent } from "../../../domain/models/SystemEvent";
import { SystemEventType } from "../../../domain/enums/SystemEventTypeEnum";
import { SystemEventParentType } from "../../../domain/enums/SystemEventParentTypeEnum";
import { SystemEventFields } from "../../../domain/enums/SystemEventFieldsEnum";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../../lib/utils";

interface SystemEventTableRowProps {
    systemEvent: SystemEvent;
    updateHandler?: (systemEvent: SystemEvent) => void;
}

const SystemEventTableRow: FC<SystemEventTableRowProps> = (props) => {
    const { t, i18n } = useTranslation();

    const getEventTypeText = (eventType: number): string => {
        const translationKey = `console.systemEvents.eventTypes.${eventType}`;
        const translation = t(translationKey);
        // Если перевод не найден (вернулся ключ), возвращаем unknown
        return translation === translationKey ? t("console.systemEvents.eventTypes.unknown") : translation;
    };

    const getParentTypeText = (parentType: number): string => {
        const translationKey = `console.systemEvents.parentTypes.${parentType}`;
        const translation = t(translationKey);
        // Если перевод не найден (вернулся ключ), возвращаем unknown
        return translation === translationKey ? t("console.systemEvents.parentTypes.unknown") : translation;
    };


    const getFieldValue = (field: SystemEventFields): string => {
        switch (field) {
            case SystemEventFields.ID:
                return props.systemEvent.id.toString();
            case SystemEventFields.PARENT_ID:
                return props.systemEvent.parentId;
            case SystemEventFields.PARENT_TYPE:
                return getParentTypeText(props.systemEvent.parentType);
            case SystemEventFields.USER_ID:
                return props.systemEvent.userId?.toString() || '-';
            case SystemEventFields.EVENT_TYPE:
                return getEventTypeText(props.systemEvent.eventType);
            case SystemEventFields.META_DATA:
                return props.systemEvent.metaData?.userFullName || '-';
            case SystemEventFields.CREATED_AT:
                return formatDateTime(props.systemEvent.createdAt, i18n.language);
            case SystemEventFields.UPDATED_AT:
                return props.systemEvent.updatedAt ? formatDateTime(props.systemEvent.updatedAt, i18n.language) : '-';
            default:
                return '-';
        }
    };

    const updateSystemEventHandler = () => {
        if (props.updateHandler) {
            props.updateHandler(props.systemEvent);
        }
    };

    return (
        <tr className="bg-light-bg-200 dark:bg-dark-bg-800 border-b hover:bg-gray-200 dark:hover:bg-dark-bg-800 border-light-border-200 dark:border-dark-border-200">
            {Object.values(SystemEventFields).map((field, index) => {
                return (
                    <td
                        key={`td-system-events-table-${index}`}
                        className={`px-2 py-1 truncate ${index === 0 ? "hover:whitespace-normal hover:overflow-visible hover:text-clip" : ""
                            } text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border`}
                    >
                        {getFieldValue(field)}
                    </td>
                );
            })}
            {/* Додаємо колонку для дій, якщо потрібно */}
            {props.updateHandler && (
                <td className="px-2 py-1 truncate text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border">
                    <div className="flex justify-center">
                        <button
                            onClick={updateSystemEventHandler}
                            className="flex items-center justify-center rounded-[8px] bg-[#5CD685E5] hover:opacity-80 w-[28px] h-[28px] mx-auto"
                            title="Переглянути деталі"
                        >
                            <span className="text-white text-xs">👁</span>
                        </button>
                    </div>
                </td>
            )}
        </tr>
    );
};

export default SystemEventTableRow;
